import {  useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeDocumentsListDisplayModel } from "../../store/slices/modalSlice";
import { Modal } from "react-bootstrap";
import axiosInstance from "../../api/axiosInstance";

interface FileEntry {
  applicantName: string;
  storedName: string;
  originalName?: string;
  label?: string;
  isGroup?: number | 0;
  RecordId: number;
}

const DocumentsListDisplayModel: React.FC = () => {
  const dispatch = useDispatch();

  const openModel = useSelector(
    (state: { modal: { documentsListDisplayModel: boolean } }) =>
      state.modal.documentsListDisplayModel
  );
  const documentData = useSelector(
    (state: {
      modal: {
        documentData: { files: FileEntry[] } | null;
      };
    }) => state.modal.documentData
  );

  const closeModel = () => {
    Object.values(documentUrls).forEach(url => {
      URL.revokeObjectURL(url);
    });
    setDocumentUrls({});
    dispatch(closeDocumentsListDisplayModel());
  };

  if (!documentData?.files || documentData.files.length === 0) {
  }
  const transformedDocumentData = documentData?.files ? [
    {
      type: "Documents",
      files: documentData.files.map((file) => ({
        label: file.label || file.originalName || "Document",
        url: "", // Will be populated by useEffect
        isPDF: file.storedName?.toLowerCase().endsWith('.pdf') || false,
        originalData: file // Keep original data for reference
      }))
    }
  ] : [];

  const [groupedData, setGroupedData] = useState<Array<{ label: string; type: string; pages: any[] }>>([]);
  const [active, setActive] = useState<{ label: string; type: string; pages: any[] } | null>(null);
  const [activeFileIndex, setActiveFileIndex] = useState<number>(0);
  const [activeDocType, setActiveDocType] = useState<string>("Documents");


useEffect(() => {
  if (!documentData?.files) return;

  const grouped: { [label: string]: any[] } = {};
  documentData.files.forEach((item) => {
    const label = item.label?.trim() || "Unknown";
    if (!grouped[label]) {
      grouped[label] = [];
    }
    grouped[label].push(item);
  });
const result = Object.entries(grouped).map(([label, items]) => {
  const pages = items.map((item, index) => {
    let shortLabel = "";

    if (items.length === 2) {
      shortLabel = index === 0 ? "Front" : "Back";
    } else {
      shortLabel = `Page ${index + 1}`;
    }

    return {
      ...item,
      groupedLabel: shortLabel,
    };
  });

  return {
    label: label.trim(),
    type: "Documents",
    pages,
  };
});


  setGroupedData(result);
  if (result.length > 0) {
    setActive(result[0]);
    setActiveFileIndex(0);
    setActiveDocType(result[0].type);
  }
}, [documentData?.files]);
  const activeFile = active?.pages[activeFileIndex];

  const [documentUrls, setDocumentUrls] = useState<{ [key: string]: string }>({});
  useEffect(() => {
    const fetchDocumentUrl = async () => {
      if (!activeFile) return;

      try {
        const response = await axiosInstance.get(
          `/api/applicantUpload/download/${activeFile.applicantName}/${activeFile.storedName}`,
          {
            responseType: "blob",
          }
        );

        if (response.data) {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"] || "application/octet-stream",
          });
          const url = URL.createObjectURL(blob);
          const fileKey = `${activeFile.applicantName}_${activeFile.storedName}`;
          setDocumentUrls(prev => ({
            ...prev,
            [fileKey]: url
          }));
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchDocumentUrl();
  }, [activeFile]);
  useEffect(() => {
    if (transformedDocumentData.length > 0 && documentUrls) {
      transformedDocumentData[0].files.forEach(file => {
        if (file.originalData) {
          const fileKey = `${file.originalData.applicantName}_${file.originalData.storedName}`;
          if (documentUrls[fileKey]) {
            file.url = documentUrls[fileKey];
          }
        }
      });
    }
  }, [documentUrls, transformedDocumentData]);

  const handleClick = (docGroup: { label: string; type: string; pages: any[] }) => {
    setActive(docGroup);
    setActiveDocType(docGroup.type);
    setActiveFileIndex(0);
  };
  const fileKey = activeFile ? `${activeFile.applicantName}_${activeFile.storedName}` : null;
  const activeFileUrl = fileKey && documentUrls[fileKey] ? documentUrls[fileKey] : "";

  return (
    <>
      <Modal
        centered
        show={openModel}
        scrollable
        onHide={closeModel}
        backdrop="static"
        dialogClassName="wide-modal"
        className="mb-fix slide-from-bottom"
      >
        <Modal.Header closeButton />
        <Modal.Body className="rounded pb-4 modal-dialog-scrollable custom-modal-dialog">
          <div className="text-center mb-3 border-bottom">
            <p className="font-18 ff-semibold text-black"> DOCUMENTS</p>
          </div>

          {groupedData.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">No documents available</p>
            </div>
          ) : (
            <div className="d-flex gap-3 layout-border rounded-3">
              {/* Left Tabs */}
              {groupedData.length > 1 && (
                <div className="border-end" style={{ width: "220px" }}>
                  {groupedData.map((docGroup, idx) => (
                    <div
                      key={idx}
                      className={`font-14 text-black d-flex justify-content-between align-items-center px-3 py-3 text-mute  border-bottom ${
                        docGroup.type === activeDocType && active?.label === docGroup.label ? "bg-light fw-semibold" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClick(docGroup)}
                    >
                      <span>{docGroup.label}</span>
                      {docGroup.type === activeDocType && active?.label === docGroup.label && (
                        <i className="bi bi-chevron-right font-12 text-muted" />
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Right Preview */}
              <div className="flex-grow-1 p-3">
                {/* Top Tabs + Download */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="flex-grow-1 text-center">
                    {active && Array.isArray(active.pages) && active.pages.length > 1 && (
                      <div className="btn-group rounded-pill border-0 overflow-hidden border bg-light">
                        {active.pages.map((file, index) => (
                          <div
                            key={index}
                            className={`px-4 py-1 border-0 font-13 ff-medium document-toggle-btn ${
                              index === activeFileIndex ? "bg-primary text-white" : ""
                            }`}
                            onClick={() => setActiveFileIndex(index)}
                          >
                            {file.groupedLabel || file.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {activeFile && (
                    <a
                      href={activeFileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      <svg
                        width="17"
                        height="19"
                        viewBox="0 0 17 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.22656 14V16C1.22656 16.5304 1.42111 17.0391 1.76739 17.4142C2.11368 17.7893 2.58335 18 3.07307 18H14.1521C14.6419 18 15.1115 17.7893 15.4578 17.4142C15.8041 17.0391 15.9987 16.5304 15.9987 16V14"
                          stroke="#676776"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4 8L8.61628 13L13.2326 8"
                          stroke="#676776"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.61719 1V13"
                          stroke="#676776"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  )}
                </div>

                {/* Document Preview */}
                <div className="text-center border rounded p-2 bg-white">
                  {activeFile ? (
                    activeFile.isPDF ? (
                      <iframe
                        src={activeFileUrl}
                        width="100%"
                        height="400px"
                        title="PDF Preview"
                      />
                    ) : (
                      <img
                        src={activeFileUrl}
                        alt={activeFile.label}
                        className="img-fluid"
                        style={{ maxHeight: "300px", objectFit: "contain" }}
                      />
                    )
                  ) : (
                    <p className="text-muted">No file selected</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DocumentsListDisplayModel;
